import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    width: {
        lg: '50%',
        xs: '85%'
    },
};

export default function BasicModal({open, setOpen, headTitle, children}) {
    const handleClose = () => setOpen(false);

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className={'border-none normal-shadow rounded mx-auto'}>
                    <Typography id="modal-modal-title" variant="h6" component="h2" className={'border-bottom pb-3'}>
                        <span>{headTitle}</span>
                    </Typography>
                    {children}
                </Box>
            </Modal>
        </div>
    );
}
